import React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from '@apollo/client/react/components';
import Styled from 'styled';

import LikeButton from 'four-nets/photoblog/posts/common/like-button/like-button';
import { HideForUnpaidVendor } from 'four-nets/vendor/permissions';
import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';

import { LikeUnlikeFragment } from './like-unlike.graphql';
import likeMutation, { likePostMutation, likePostMutationVariables } from './mutations/like.graphql';
import unlikeMutation, { unlikePostMutation, unlikePostMutationVariables } from './mutations/unlike.graphql';

import defaultStyles from './like-unlike.scss';

export interface Props extends LikeUnlikeFragment {
    styles: typeof defaultStyles;
    inFeed?: boolean;
}

class LikeUnlike extends React.PureComponent<Props> {
    static contextTypes = {
        authCheck: PropTypes.func,
    };
    render() {
        const { id, likesCount, isLikedByViewer, inFeed } = this.props;

        return (
            <Mutation<likePostMutation, likePostMutationVariables>
                mutation={likeMutation}
                optimisticResponse={{
                    likePost: {
                        __typename: 'LikePostPayload',
                        post: {
                            __typename: 'PostNode',
                            id,
                            isLikedByViewer: true,
                            likesCount: likesCount || 0 + 1,
                        },
                    },
                }}
            >
                {likePost => (
                    <Mutation<unlikePostMutation, unlikePostMutationVariables>
                        mutation={unlikeMutation}
                        optimisticResponse={{
                            unlikePost: {
                                __typename: 'UnlikePostPayload',
                                post: {
                                    __typename: 'PostNode',
                                    id,
                                    isLikedByViewer: false,
                                    likesCount: likesCount || 1 - 1,
                                },
                            },
                        }}
                    >
                        {unlikePost => (
                            <HideForUnpaidVendor>
                                <LikeButton
                                    likesCount={likesCount}
                                    onClick={() =>
                                        this.context.authCheck(() => {
                                            if (isLikedByViewer) {
                                                return unlikePost({ variables: { id } });
                                            } else {
                                                return likePost({ variables: { id } });
                                            }
                                        }, AuthOrigin.LikeBlogPost)
                                    }
                                    isLikedByViewer={isLikedByViewer || false}
                                    inFeed={inFeed}
                                />
                            </HideForUnpaidVendor>
                        )}
                    </Mutation>
                )}
            </Mutation>
        );
    }
}

export default Styled(defaultStyles)(LikeUnlike);
